import {connect} from "react-redux";
import * as InfoActions from '../../store/actions/infoActions';
import * as AuthActions from '../../store/actions/authActions';
import Settings from "../../components/Settings/Settings";
import * as VideoActions from '../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    onBasicInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateBasicUserInfo(update, token));
    },
    onContactsInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateContactsUserInfo(update, token));
    },
    createLog: (log, token) => {
        dispatch(VideoActions.createLog(log, token));
    },
    updateLog: (log, token) => {
        dispatch(VideoActions.updateLog(log, token));
    },
    updateProfile: (profile, token) => {
        dispatch(InfoActions.updateProfile(profile, token));
    },
    updateUser: (token, user) => {
        dispatch(AuthActions.updateUser(token, user))
    },
    uploadAvatar: (data, profileId, token) => {
        dispatch(AuthActions.uploadAvatar(data, profileId, token));
    },
    getOfficialTests: (profileId, token) => {
        dispatch(AuthActions.getOfficialTests(profileId, token));
        dispatch(AuthActions.getAllCourses());
    },
    updateOfficialTest: (test, token) => {
        dispatch(AuthActions.updateOfficialTest(test, token));
    },
    deleteOfficialTest: (testId, token) => {
        dispatch(AuthActions.deleteOfficialTest(testId, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);


// WEBPACK FOOTER //
// ./src/containers/Settings/SettingsContainer.js